package org.multiplatform.kotfolio.pages.listing

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.components.WebImage
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import org.multiplatform.kotfolio.util.Resources

@Page("step_ladder")
@Composable
fun StepLadderListing() {
    BlogLayout(
        PageProperties(
            "Step Ladder",
            ""
        ),
        BlogProperties("Listing", "Step Ladder - (Foldable Multipurpose Collapsible Ladder (Telescopic Ladder/Carbon), Aluminium ladder)")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {

            WebImage(
                src = Resources.Images.STEP_LADDER_PRODUCT,
                modifier = Modifier.fillMaxWidth().padding(5.px).borderRadius(10.px),
                contentDescription = "Step Ladder"
            )

            WebImage(
                src = Resources.Images.STEP_LADDER_2_PRODUCT,
                modifier = Modifier.fillMaxWidth().padding(5.px).borderRadius(10.px),
                contentDescription = "Step Ladder Description"
            )

            SpanText(
                text = "Images Title",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Knee Guard, Anti-Skid, Pro Hinge Technology, Ultra Sturdy, 100% Aluminium, Large Platform, Rust Proof, Water Proof, Anti Sleep Platform",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Sure-Hinge Technology: Double-locking pivot joints for a stable & wobble-free experience. (Double-locking pivot joints ensure flawless Stability every time)",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Slip-Proof Steps with Edge Guards: Parallel ridges and edge guards offer Enhanced grip and step security.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Foldable Design: Compact and space-saving for easy Storage and transport.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Large Platform: Large top platform for you to stand with comfort",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Anti-Slip Steps & Edge Guards: Slip-proof steps for maximum stability & safety",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Anti-Slip Shoes: Anti-slip shoes to prevent slipping on a wet floor. (Firm footing, even on wet surfaces Engineered for your safety)",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Title",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Mild Steel Multipurpose Climb Swift for reaching high areas around the house (3,4,5,6,7) - Step Foldable Ladder",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Heavy Foldable Cameo 5 Steps Ladder with Wide Steps & Anti-Skid Shoes - Black Steel Ladder (With Platform, Hand Rail)",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Safety Step Ladder - Foldable Aluminium (3,4,5,6,7) - Step with Safety Handrails & Non-Slip Feet",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Foldable Step Ladder with Safety Clutch Lock With Color Variation/Scheme (Yellow & Black & White & Grey)",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Heavy Duty Metal Folding Multi-Step Ladder",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Smartslide Heavy Duty Foldable 4 Step Ladder",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }


                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Load Capacity Up to 120kg",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Anti-Slip Designed for Indoor & Outdoor Use - (Yellow & Black & White & Grey)",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Description keyword",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Versatile and stylish",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Key Features",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Heavy-Duty Metal Construction: Made from high-strength metal with reinforced joints, providing superior stability, durability, and long-lasting performance for daily household or work use.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                 Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Superior Safety & Stability: Features wide anti-skid steps and robust anti-slip foot pads, ensuring maximum grip and preventing accidents during any household task.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Wide Non-Slip Steps: Each step features a textured, anti-slip surface for enhanced grip, reducing the risk of slipping and ensuring safe climbing and standing.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Built-In Tool Holder: Top tool platform holds tools, screws and accessories, keeping everything within reach and reducing the need for repeated climbing.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Foldable & Space-Saving: Folds flat quickly for convenient storage behind doors, under beds, or in closets when not in use.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "𝐂𝐨𝐦𝐩𝐚𝐜𝐭 𝐃𝐢𝐦𝐞𝐧𝐬𝐢𝐨𝐧𝐬: When closed, the ladder measures (L) 6 cm x (W) 55 cm x (H) 234 cm; when open, it extends to (L) 136 cm x (W) 55 cm x (H) 217 cm.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "𝐔𝐬𝐞𝐫-𝐅𝐫𝐢𝐞𝐧𝐝𝐥𝐲 𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬: With a top platform height of 163 cm, wide 30 x 20 cm steps, and evenly spaced steps at 24 cm intervals, this ladder offers comfort and security during use.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "𝐖𝐢𝐝𝐞 & 𝐍𝐨𝐧-𝐒𝐥𝐢𝐩 𝐒𝐭𝐞𝐩𝐬: The ladder is pre-assembled with 6 spacious steps made from durable PPCP material. Each step is designed for full foot coverage, giving excellent grip and comfort during use.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Product Specification",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Material: Metal + Plastic",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Color: Black | Grey | White",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "No. of Steps: 3, 4, 5, 6 and 7",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Design: Foldable, freestanding",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Package Weight: 12.82",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Dimensions: 4-Step 39.5 x 60 x 123cm",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Description",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The Heavy Duty Metal Folding Step Ladder with Tool Tray is designed to provide maximum stability, safety, and convenience for everyday home and professional use. Built with a strong metal frame and wide anti-slip steps, it ensures secure footing while working at height. The integrated tool tray on top keeps tools, screws, paint cans, and accessories within easy reach, improving efficiency and reducing repeated climbing. Its foldable design allows easy storage in compact spaces, making it ideal for homes, garages, workshops, and offices.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }
        }
    }
}

//COME ONCE & GET CONVINCED
//919106397438
//918147896415

//"Modern plastic wardrobe with dustproof & moisture-resistant design for long-lasting use!"
//"Durable plastic cabinet with spacious compartments – easy to clean & maintain!"
//"Strong & lightweight plastic wardrobe with multiple shelves for organized storage!"

//https://homeessentials.in
//https://utillo.in/products/
//https://www.bathla.com/ (Not good)